/**
 * Copyright 2018-present MongoDB, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { GoogleAuthProvider } from "mongodb-stitch-core-sdk";
import StitchRedirectCredential from "../StitchRedirectCredential";

/**
 * A credential which can be used with {@link StitchAuth.loginWithRedirect} to
 * login to Stitch via Google OAuth.
 */
export default class GoogleRedirectCredential
  implements StitchRedirectCredential {
  public constructor(
    public readonly redirectUrl?: string,
    public readonly providerName = GoogleAuthProvider.DEFAULT_NAME,
    public readonly providerType = GoogleAuthProvider.TYPE
  ) {}
}
